import { publicEmailDomainSchema } from "@redotech/redo-model/email/email-domain";
import * as z from "zod/v4";

export const getEmailDomains = {
  name: "getEmailDomains" as const,
  input: z.object({}),
  output: z.object({ domains: z.array(publicEmailDomainSchema) }),
};
